import { render, staticRenderFns } from "./CreatorPostView.vue?vue&type=template&id=d84dc0a6&"
import script from "./CreatorPostView.vue?vue&type=script&lang=js&"
export * from "./CreatorPostView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports